import { Testimonial } from '../types';

export const testimonials: Testimonial[] = [
    {
        id: 1,
        name: 'Mr. Manoj Shah',
        company: 'Shah Engineering Works',
        role: 'Owner',
        image: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=400',
        rating: 5,
        text: 'Asus Spare Parts consistently delivers dependable components that help us maintain smooth operations. Their attention to detail and customer-first approach make them a partner we genuinely trust.'
    },

    {
        id: 2,
        name: 'Mr. Prem Kr. Gupta',
        company: 'Jai Maa Ambeshwari Earthmovers',
        role: 'Owner',
        image: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=400',
        rating: 5,
        text: 'Working with Asus has brought remarkable stability to our workflow. Their premium parts and prompt support ensure minimal downtime and maximum efficiency every single day.'
    },

    {
        id: 3,
        name: 'Mr. Ashok Yadav',
        company: 'New Gayatri Earthmovers',
        role: 'Owner',
        image: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=400',
        rating: 5,
        text: 'Asus impressed us with their technical expertise and clarity. They recommended the perfect components for our machines and guided us through every installation step with complete professionalism.'
    },

    {
        id: 4,
        name: 'Mr. Ajay Singh',
        company: 'Super Heavy Equipments',
        role: 'Quality Supervisor',
        image: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=400',
        rating: 5,
        text: 'Exceptional quality and fast delivery—Asus never disappoints. Their OEM-grade parts, especially hydraulic seal kits, have proven to be reliable and long-lasting for our entire fleet.'
    },

    {
        id: 5,
        name: 'Mr. Ishant Yadav',
        company: 'Balaji Traders',
        role: 'CEO',
        image: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=400',
        rating: 5,
        text: 'Asus stands out for its deep product knowledge and commitment to customer satisfaction. They made the selection process incredibly easy and ensured we received parts that performed flawlessly.'
    },

    {
        id: 6,
        name: 'Mr. Dev Thakur',
        company: 'SD Enterprises',
        role: 'Maintenance Supervisor',
        image: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=400',
        rating: 5,
        text: 'Asus has become our preferred source for reliable spare parts. Their competitive pricing, quick dispatch, and authentic OEM quality give us complete confidence in every purchase.'
    }
];
